import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { api, apiErr } from "../lib/api";
import { BrandLogo } from "../components/BrandLogo";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState("loading"); // loading | ok | error
  const [msg, setMsg] = useState("");

  useEffect(() => {
    if (!token) { setState("error"); setMsg("Link non valido."); return; }
    api.post("/auth/verify-email", { token })
      .then(() => setState("ok"))
      .catch((e) => { setState("error"); setMsg(apiErr(e)); });
  }, [token]);

  return (
    <div className="min-h-screen bg-[#0B0B0D] text-white flex flex-col items-center justify-center px-4">
      <motion.div initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-sm text-center" data-testid="verify-email">
        <div className="mb-6 flex justify-center"><BrandLogo name="Pickfood" size={30} /></div>
        {state === "loading" && <Loader2 className="animate-spin text-[#FFC400] mx-auto" size={32} />}
        {state === "ok" && (
          <>
            <CheckCircle2 className="text-[#FFC400] mx-auto mb-3" size={44} />
            <h1 className="font-head text-2xl font-bold">Email confermata!</h1>
            <p className="text-white/60 text-sm mt-2">Il tuo account è ora verificato. Grazie!</p>
            <Link to="/account" className="inline-block mt-6 bg-[#FFC400] hover:bg-[#E6AC00] text-[#0B0B0D] font-semibold rounded-full px-6 py-2.5">Vai al mio account</Link>
          </>
        )}
        {state === "error" && (
          <>
            <XCircle className="text-red-400 mx-auto mb-3" size={44} />
            <h1 className="font-head text-2xl font-bold">Verifica non riuscita</h1>
            <p className="text-white/60 text-sm mt-2">{msg}</p>
            <Link to="/account" className="inline-block mt-6 text-[#FFC400] font-semibold hover:underline">Vai al mio account →</Link>
          </>
        )}
      </motion.div>
    </div>
  );
}
